
import { paramsSubstituteTranslate } from '@/plugins/i18n'
import { useNotify } from './notify'

import { useDetectDevice } from '@/composables/device'

export const useException = () => {
  const processError = async(err) => {
    if (!err.config || !err.config.skipErrorMessage) {
      let message = 'error.generic'
      let params = {}
      let type = 'error'

      if (err) {
        message = err.message || err
      }

      if (err.response && err.response.data) {
        const data = err.response.data
        message = data.message || data.toString()
        params = data.params || {}

        if (data.code) {
          message = data.code
        }

        if (Array.isArray(data.details) && data.details.length > 0) {
          const detail = data.details[0]

          if (Array.isArray(detail.errors) && detail.errors.length > 0) {
            const error = detail.errors[0]

            message = error.code || message
            params = error.params || {}

            const { isMobile } = useDetectDevice()

            if (isMobile && Array.isArray(params) && params.length > 0) {
              // On mobile, concat all params into one string to save space
              params = { detail: params.join(', ') }
            }

            if (detail.target === 'warning') {
              type = 'warning'
            }
          }
        }
      }
      if (err.response?.status === 404) {
        if (window.config.IS_DEBUG) {
          console.debug(`${err.response.statusText} - ${err.response.config.url}`)
        } else {
          message = 'warning.file_not_found'
          type = 'warning'
        }
      } else if (message.startsWith('error.')) {
        type = 'error'
      } else if (message.startsWith('warning.')) {
        type = 'warning'
      } else {
        message = 'error.generic'
      }
      const { notifyError, notifyWarning } = useNotify()
      if (type === 'warning') {
        notifyWarning(paramsSubstituteTranslate(message, params) || message)
      } else {
        notifyError(paramsSubstituteTranslate(message, params) || message)
      }
    }
  }

  return { processError }
}
